import React from 'react';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import axios from "axios";
import auth from '../../../auth/';

import api from '../../../api/';

import { Row, Col, Button } from 'reactstrap';


const Edit = (props) => {
  const getdb = () => {
    axios.get(api.backup.listdb, auth.header())
      .then((response) => {
        window.open(response.data.url, "")
      });
  };

  const getzip = () => {
    axios.get(api.backup.linkzip, auth.header())
      .then((response) => {
        window.open(response.data.url, "")
      });
  };
  return (
    <ParadigmaModal
      navButton={(props.nav ? true : false)}
      nav={props.nav}
      title={"Generacion de Backup"}
      buttonTitle={"Editar"}
      buttonIcon={"fa fa-pencil fa-lg"}
      saveButton={false}
      closeButton={true}
      className={'modal-sm'}
    >

      <Row>
        <Col className={"col-12 text-center"}>
          <Button color='primary' onClick={getdb} className="rounded">
            <i class="fa fa-database" aria-hidden="true"></i>{" Base de Datos"}
          </Button>
          {" "}
          <Button color='primary' onClick={getzip} className="rounded">
            <i class="fa fa-file-archive-o" aria-hidden="true"></i>{" Archivos"}
          </Button>
        </Col>
      </Row>

    </ParadigmaModal>
  );
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Config/Backup/ModalBackup.js